import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { DevPortalOrgHubClient, devPortalOrgHubApiRef } from './api';

export const devportalOrgHubPlugin = createPlugin({
  id: 'devportal-org-hub',
  apis: [
    createApiFactory({
      api: devPortalOrgHubApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) => {
        return DevPortalOrgHubClient.fromConfig(discoveryApi, fetchApi);
      },
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const DevportalOrgHubPage = devportalOrgHubPlugin.provide(
  createRoutableExtension({
    name: 'DevportalOrgHubPage',
    component: () => import('./components/Router').then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);
